/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Again_Button_CapInputs */

const en_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const id_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba lagi`)
};

const ms_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba lagi`)
};

const ca_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna-ho a provar`)
};

const cs_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkusit znovu`)
};

const da_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igen`)
};

const de_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const et_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proovi uuesti`)
};

const es_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a intentar`)
};

const fr_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const hr_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokušaj ponovo`)
};

const it_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const lv_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēģināt vēlreiz`)
};

const lt_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandyti dar kartą`)
};

const hu_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Újrapróbálás`)
};

const nl_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer opnieuw`)
};

const nb_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igjen`)
};

const pl_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbuj ponownie`)
};

const pt_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const ro_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încercați din nou`)
};

const sk_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skúsiť znovu`)
};

const sl_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poskusite znova`)
};

const fi_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritä uudelleen`)
};

const sv_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Försök igen`)
};

const vi_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const tr_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden deneyin`)
};

const el_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προσπάθησε ξανά`)
};

const bg_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нов опит`)
};

const ru_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить`)
};

const sr_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробајте поново`)
};

const uk_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спробувати ще раз`)
};

const ka_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ხელახლა სცადეთ`)
};

const hi_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोबारा कोशिश करें`)
};

const th_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองใหม่อีกครั้ง`)
};

const ko_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

const zh_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_tw_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試一次`)
};

const ja_try_again_button_cap = /** @type {(inputs: Try_Again_Button_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Try_Again_Button_CapInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const try_again_button_cap = /** @type {((inputs?: Try_Again_Button_CapInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Again_Button_CapInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_try_again_button_cap(inputs)
	if (locale === "ms") return ms_try_again_button_cap(inputs)
	if (locale === "ca") return ca_try_again_button_cap(inputs)
	if (locale === "cs") return cs_try_again_button_cap(inputs)
	if (locale === "da") return da_try_again_button_cap(inputs)
	if (locale === "de") return de_try_again_button_cap(inputs)
	if (locale === "et") return et_try_again_button_cap(inputs)
	if (locale === "es") return es_try_again_button_cap(inputs)
	if (locale === "fr") return fr_try_again_button_cap(inputs)
	if (locale === "hr") return hr_try_again_button_cap(inputs)
	if (locale === "it") return it_try_again_button_cap(inputs)
	if (locale === "lv") return lv_try_again_button_cap(inputs)
	if (locale === "lt") return lt_try_again_button_cap(inputs)
	if (locale === "hu") return hu_try_again_button_cap(inputs)
	if (locale === "nl") return nl_try_again_button_cap(inputs)
	if (locale === "nb") return nb_try_again_button_cap(inputs)
	if (locale === "pl") return pl_try_again_button_cap(inputs)
	if (locale === "pt") return pt_try_again_button_cap(inputs)
	if (locale === "ro") return ro_try_again_button_cap(inputs)
	if (locale === "sk") return sk_try_again_button_cap(inputs)
	if (locale === "sl") return sl_try_again_button_cap(inputs)
	if (locale === "fi") return fi_try_again_button_cap(inputs)
	if (locale === "sv") return sv_try_again_button_cap(inputs)
	if (locale === "vi") return vi_try_again_button_cap(inputs)
	if (locale === "tr") return tr_try_again_button_cap(inputs)
	if (locale === "el") return el_try_again_button_cap(inputs)
	if (locale === "bg") return bg_try_again_button_cap(inputs)
	if (locale === "ru") return ru_try_again_button_cap(inputs)
	if (locale === "sr") return sr_try_again_button_cap(inputs)
	if (locale === "uk") return uk_try_again_button_cap(inputs)
	if (locale === "ka") return ka_try_again_button_cap(inputs)
	if (locale === "hi") return hi_try_again_button_cap(inputs)
	if (locale === "th") return th_try_again_button_cap(inputs)
	if (locale === "ko") return ko_try_again_button_cap(inputs)
	if (locale === "zh") return zh_try_again_button_cap(inputs)
	if (locale === "zh-tw") return zh_tw_try_again_button_cap(inputs)
	if (locale === "ja") return ja_try_again_button_cap(inputs)
	return en_try_again_button_cap(inputs)
});